import React from "react";
import { EditZoneStage1Page } from "./stage1";
import { EditZoneStage2Page } from "./stage2";
import { useGetZoneQuery } from '@src/features/zones/redux';
import { useParams, useSearchParams } from "react-router-dom";

export const EditZonePage: React.FC = () => {
  const { id } = useParams();
  const [searchParams] = useSearchParams();   
  const stage = searchParams.get('stage') ?? '1';
  if (!id) {
    return null;
  }

  const { data: zone } = useGetZoneQuery(+id, { skip: !id });
  if (!zone) {
    return null;
  }
  return (
    <React.Fragment>
      {stage === '2' ? <EditZoneStage2Page zone={zone} /> : <EditZoneStage1Page zone={zone} />}
    </React.Fragment>
  );
};